/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetOrganizationAddressesResponse,
  GetOrganizationContactsResponse,
  ListRequest,
  ListResponseOfOrganizationSuggestion
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const getOrganizationSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfOrganizationSuggestion>(
      {url: `/api/general/organizations/suggestions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetOrganizationSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrganizationSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getOrganizationSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getOrganizationSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getOrganizationSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getOrganizationSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetOrganizationSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getOrganizationSuggestions>>>
    export type GetOrganizationSuggestionsMutationBody = ListRequest
    export type GetOrganizationSuggestionsMutationError = ErrorType<unknown>

    export const useGetOrganizationSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrganizationSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getOrganizationSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetOrganizationSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGeneralOrganizationAddresses = (
    partyId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetOrganizationAddressesResponse>(
      {url: `/api/general/organizations/${partyId}/addresses`, method: 'GET', signal
    },
      );
    }
  



export const getGetGeneralOrganizationAddressesQueryKey = (partyId?: number,) => {
    return [
    `/api/general/organizations/${partyId}/addresses`
    ] as const;
    }

    
export const getGetGeneralOrganizationAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError = ErrorType<unknown>>(partyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGeneralOrganizationAddressesQueryKey(partyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>> = ({ signal }) => getGeneralOrganizationAddresses(partyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(partyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGeneralOrganizationAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>>
export type GetGeneralOrganizationAddressesQueryError = ErrorType<unknown>


export function useGetGeneralOrganizationAddresses<TData = Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError = ErrorType<unknown>>(
 partyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>,
          TError,
          Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralOrganizationAddresses<TData = Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError = ErrorType<unknown>>(
 partyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>,
          TError,
          Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralOrganizationAddresses<TData = Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError = ErrorType<unknown>>(
 partyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGeneralOrganizationAddresses<TData = Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError = ErrorType<unknown>>(
 partyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationAddresses>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGeneralOrganizationAddressesQueryOptions(partyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGeneralOrganizationContacts = (
    partyId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetOrganizationContactsResponse>(
      {url: `/api/general/organizations/${partyId}/contacts`, method: 'GET', signal
    },
      );
    }
  



export const getGetGeneralOrganizationContactsQueryKey = (partyId?: number,) => {
    return [
    `/api/general/organizations/${partyId}/contacts`
    ] as const;
    }

    
export const getGetGeneralOrganizationContactsQueryOptions = <TData = Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError = ErrorType<unknown>>(partyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGeneralOrganizationContactsQueryKey(partyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeneralOrganizationContacts>>> = ({ signal }) => getGeneralOrganizationContacts(partyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(partyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGeneralOrganizationContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getGeneralOrganizationContacts>>>
export type GetGeneralOrganizationContactsQueryError = ErrorType<unknown>


export function useGetGeneralOrganizationContacts<TData = Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError = ErrorType<unknown>>(
 partyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralOrganizationContacts>>,
          TError,
          Awaited<ReturnType<typeof getGeneralOrganizationContacts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralOrganizationContacts<TData = Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError = ErrorType<unknown>>(
 partyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralOrganizationContacts>>,
          TError,
          Awaited<ReturnType<typeof getGeneralOrganizationContacts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralOrganizationContacts<TData = Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError = ErrorType<unknown>>(
 partyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGeneralOrganizationContacts<TData = Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError = ErrorType<unknown>>(
 partyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralOrganizationContacts>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGeneralOrganizationContactsQueryOptions(partyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




